// extracted by mini-css-extract-plugin
export default {"se-color-palette":"Mission_se-color-palette__B98oJ"};